import { useEffect, useState } from 'react';
import Navbar from '../../sharedComponents/Navbar/Navbar';
import Footer from '../Footer/Footer';
import AboutLayout from '../LayoutModules/AboutLayout';
import ContactLayout from '../LayoutModules/ContactLayout';
import HomePageLayout from '../LayoutModules/HomePageLayout';
import ProductsLayout from '../LayoutModules/ProductsLayout';
import ResearchLayout from '../LayoutModules/ResearchLayout';
import './Layout.scss';
import { Theme } from '../coreFiles/types';

interface LayoutProps {
  activePage?: string;
}

const Layout: React.FC<LayoutProps> = ({
  activePage = 'Main'
}) => {

  const [theme, setTheme] = useState<Theme>('light');
  useEffect(() => {
    // Set theme based on active page
    if (activePage === 'Contact') {
      setTheme('light');
    } else {
      setTheme('dark'); // Reset to light theme for all other pages
    }
  }, [activePage]);

  return (
    <div className={`${theme}__background`} >
      <Navbar />
      {activePage === 'Main' && (<HomePageLayout />)}
      {activePage === 'Products' && (<ProductsLayout />)}
      {activePage === 'Research' && (<ResearchLayout />)}
      {activePage === 'Contact' && (<ContactLayout />)}
      {activePage === 'About' && (<AboutLayout />)}
      <Footer theme={theme}/>
    </div>
  );
}

export default Layout;

